document.addEventListener('DOMContentLoaded', function () {
  const readMoreButtons = document.querySelectorAll('.event-list-item__read-more-btn, .section-event-highlight__read-more-btn');

  readMoreButtons.forEach(function (readMoreBtn) {
    let eventId = readMoreBtn.id.replace('read-more-btn-', '');
    let description = document.getElementById('event-description-' + eventId);
    const readMoreText = readMoreBtn.querySelector('.read-more-text');
    const readLessText = readMoreBtn.querySelector('.read-less-text');

    if (description && readMoreBtn) {
      function getLineHeight() {
        const computedStyle = window.getComputedStyle(description);
        const lineHeight = parseFloat(computedStyle.lineHeight);
        if (isNaN(lineHeight) || computedStyle.lineHeight === 'normal') {
          const fontSize = parseFloat(computedStyle.fontSize);
          return fontSize * 1.4;
        }
        return lineHeight;
      }

      function getMaxHeight() {
        return getLineHeight() * 2;
      }

      function hasMoreThan2Lines() {
        description.style.height = 'auto';
        const totalHeight = description.scrollHeight;
        const maxHeight = getMaxHeight();
        return totalHeight > maxHeight + 5;
      }

      if (hasMoreThan2Lines()) {
        const maxHeight = getMaxHeight();
        description.style.height = maxHeight + 'px';
        description.classList.add('event-description-collapsed');
        readMoreBtn.style.display = 'inline-block';
        readMoreText.style.display = 'inline';
        readLessText.style.display = 'none';
        readMoreBtn.setAttribute('aria-expanded', 'false');

        readMoreBtn.addEventListener('click', function () {
          const isExpanded = readMoreBtn.getAttribute('aria-expanded') === 'true';
          if (isExpanded) {
            const maxHeight = getMaxHeight();
            description.style.height = maxHeight + 'px';
            description.classList.add('event-description-collapsed');
            readMoreText.style.display = 'inline';
            readLessText.style.display = 'none';
            readMoreBtn.setAttribute('aria-expanded', 'false');
          } else {
            description.style.height = description.scrollHeight + 'px';
            description.classList.remove('event-description-collapsed');
            readMoreText.style.display = 'none';
            readLessText.style.display = 'inline';
            readMoreBtn.setAttribute('aria-expanded', 'true');
          }
        });
      } else {
        readMoreBtn.style.display = 'none';
        description.style.height = 'auto';
        description.classList.remove('event-description-collapsed');
      }
    }
  });
}); 